import { useConnect } from '@lore/query-connect';
import { tags_educator, user_networkId, user_tags_educator } from '@/utils/query-helpers';
import _ from 'lodash';

export default function useSchools(network, schoolStart, schoolEnd, extra = {}, eager = {}) {
  return useConnect('site.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfEducators',
            relation: 'users',
            $where: {
              ...tags_educator(),
              networkId: network?.id
            }
          },
          {
            type: 'count',
            alias: 'numberOfRoles',
            relation: 'roles',
            $where: {
              ..._.merge(
                {},
                user_tags_educator(),
                user_networkId(network)
              ),
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              },
            }
          }
        ],
        $where: {
          ...extra
        },
        $eager: eager,
        $having: {
          numberOfEducators: {
            $gt: 0
          },
          numberOfRoles: {
            $gt: 0
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
